import {
    housefront,
    roofslope,
    penetration,
    ridgecap,
    metalflashings,
    miscellaneous,
} from "./imageAssetsBase64";

export const buildingPermitPhotoSections = [
    {
        id: "before_frontProperty",
        title: "Front of Property – Before Work",
        label: "TASK:BUILDING_PERMIT:FHSA",
        description:
            "Take a wide photo showing the entire front of the property, including the visible address, before any construction or roofing work begins.",
        coverImage: housefront,
    },
    {
        id: "before_roofOverview",
        title: "Roof Overview – Existing Condition",
        label: "TASK:BUILDING_PERMIT:ROOF_OVERVIEW_BEFORE",
        description:
            "Capture a wide shot of the existing roof showing its overall condition and materials before removal or repair.",
        coverImage: roofslope,
    },
    {
        id: "before_closeUpRoof",
        title: "Close-Up – Roof Surface (Before Work)",
        label: "TASK:BUILDING_PERMIT:ROOF_CLOSEUP_BEFORE",
        description:
            "Take detailed photos of the existing roof surface, including shingles, tiles, or other materials showing wear or damage.",
        coverImage: penetration,
    },
    {
        id: "before_eavesFascia",
        title: "Eaves / Fascia / Soffit – Before Work",
        label: "TASK:BUILDING_PERMIT:EAVES_BEFORE",
        description:
            "Capture clear images of the eaves, fascia, and soffit areas to document pre-work conditions.",
        coverImage: metalflashings,
    },
    {
        id: "before_sideRear",
        title: "Side and Rear Elevations – Before Work",
        label: "TASK:BUILDING_PERMIT:SIDE_REAR_BEFORE",
        description:
            "Take wide photos showing the side and rear of the structure before work begins.",
        coverImage: housefront,
    },
    {
        id: "during_roofDecking",
        title: "Roof Decking – In Progress",
        label: "TASK:BUILDING_PERMIT:ROOF_DECKING",
        description:
            "Take photos showing the roof decking after tear-off to document sheathing condition before new material installation.",
        coverImage: roofslope,
    },
    {
        id: "during_underlayment",
        title: "Underlayment Installation – In Progress",
        label: "TASK:BUILDING_PERMIT:UNDERLAYMENT",
        description:
            "Capture photos showing proper installation of felt or synthetic underlayment across the roof surface.",
        coverImage: miscellaneous,
    },
    {
        id: "during_flashingVents",
        title: "Flashing and Vent Installation – In Progress",
        label: "TASK:BUILDING_PERMIT:FLASHING_VENTS",
        description:
            "Take photos of step flashing, pipe jacks, valley metal, and other flashing or vent installations to confirm compliance.",
        coverImage: metalflashings,
    },
    {
        id: "during_fasteners",
        title: "Nailing / Fastener Pattern – In Progress",
        label: "TASK:BUILDING_PERMIT:FASTENERS",
        description:
            "Provide close-up images showing nail or fastener spacing and placement for building code verification.",
        coverImage: ridgecap,
    },
    {
        id: "after_frontProperty",
        title: "Front of Property – After Work",
        label: "TASK:BUILDING_PERMIT:FHSA_AFTER",
        description:
            "Take a wide photo showing the entire front of the property, including the visible address, after all roofing work has been completed.",
        coverImage: housefront,
    },
    {
        id: "after_roofOverview",
        title: "Roof Overview – Completed Work",
        label: "TASK:BUILDING_PERMIT:ROOF_OVERVIEW_AFTER",
        description:
            "Capture a wide photo showing the finished roof surface, including all slopes and ridges.",
        coverImage: roofslope,
    },
    {
        id: "after_closeUpDetails",
        title: "Close-Up – Flashing, Vents, and Edges",
        label: "TASK:BUILDING_PERMIT:ROOF_DETAILS_AFTER",
        description:
            "Take close-up photos showing final flashing, vent seals, drip edges, and other finishing details.",
        coverImage: penetration,
    },
    {
        id: "after_guttersEaves",
        title: "Gutters, Eaves, and Ridge Details – Completed Work",
        label: "TASK:BUILDING_PERMIT:GUTTERS_AFTER",
        description:
            "Capture photos of gutters, eaves, ridges, and other components to confirm proper installation and finishing.",
        coverImage: metalflashings,
    },
    {
        id: "after_permitSticker",
        title: "Permit Sticker / Final Inspection Tag",
        label: "TASK:BUILDING_PERMIT:PERMIT_TAG",
        description:
            "Take a clear photo of the posted permit or final inspection sticker as required by the building department.",
        coverImage: miscellaneous,
    },
];
